import React from 'react';
import styled from 'styled-components';

const FooterBar = styled.footer`
  height: ${props => props.theme.layout.footerHeight};
  background: ${props => props.theme.colors.grayLight};
  border-top: 1px solid ${props => props.theme.colors.border};
  display: flex;
  align-items: center;
`;

const Container = styled.div`
  max-width: ${props => props.theme.sizes.container.xl};
  margin: 0 auto;
  width: 100%;
  padding: 0 20px;
  color: ${props => props.theme.colors.textSecondary};
  text-align: center;
  font-size: 14px;
`;

const Footer = () => (
  <FooterBar>
    <Container>
      © {new Date().getFullYear()} Santa Casa Copacabana — Todos os direitos reservados
    </Container>
  </FooterBar>
);

export default Footer;


